module.exports = __webpack_public_path__ + "e714f34086b749c7f7b3906840bd7cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/circle-avatar.png
// module id = 848
// module chunks = 0